import React from 'react';
import './VirtualKeyboard.css';

const VirtualKeyboard = ({ 
  show, 
  mode, 
  onKeyPress, 
  onClose, 
  isUppercase, 
  onToggleCase 
}) => {
  const numericKeys = [
    ['1', '2', '3'],
    ['4', '5', '6'],
    ['7', '8', '9'],
    ['Clear', '0', 'Backspace']
  ];

  const qwertyKeys = [
    ['q', 'w', 'e', 'r', 't', 'y', 'u', 'i', 'o', 'p'],
    ['a', 's', 'd', 'f', 'g', 'h', 'j', 'k', 'l'],
    ['Shift', 'z', 'x', 'c', 'v', 'b', 'n', 'm', 'Backspace'],
    ['Space']
  ];

  const handleKeyPress = (key) => {
    if (key === 'Shift') {
      onToggleCase();
      return;
    }
    
    if (key === 'Space') {
      onKeyPress(' ');
      return;
    }
    
    if (mode === 'text' && key.length === 1) {
      onKeyPress(isUppercase ? key.toUpperCase() : key);
      return;
    }
    
    onKeyPress(key);
  };

  const renderNumericKeyboard = () => (
    <div className="keyboard-grid numeric-grid">
      {numericKeys.map((row, rowIndex) => (
        <div key={rowIndex} className="keyboard-row">
          {row.map((key) => (
            <button
              key={key}
              className={`keyboard-key ${key === 'Clear' || key === 'Backspace' ? 'special-key' : ''}`}
              onClick={() => handleKeyPress(key)}
            >
              {key === 'Backspace' ? '⌫' : key}
            </button>
          ))}
        </div>
      ))}
      <div className="keyboard-row">
        <button className="keyboard-key done-key" onClick={onClose}>
          Done
        </button>
      </div>
    </div>
  );

  const renderTextKeyboard = () => (
    <div className="keyboard-grid text-grid">
      {qwertyKeys.map((row, rowIndex) => (
        <div key={rowIndex} className="keyboard-row">
          {row.map((key) => {
            let displayKey = key;
            let className = 'keyboard-key';
            
            if (key === 'Shift') {
              className += ' shift-key';
              displayKey = isUppercase ? '⇧' : '⇧';
              if (isUppercase) className += ' active';
            } else if (key === 'Backspace') {
              className += ' special-key';
              displayKey = '⌫';
            } else if (key === 'Space') {
              className += ' space-key';
              displayKey = 'Space';
            } else if (key.length === 1) {
              displayKey = isUppercase ? key.toUpperCase() : key;
            }
            
            return (
              <button
                key={key}
                className={className}
                onClick={() => handleKeyPress(key)}
              >
                {displayKey}
              </button>
            );
          })}
        </div>
      ))}
      <div className="keyboard-row">
        <button className="keyboard-key done-key" onClick={onClose}>
          Done
        </button>
      </div>
    </div>
  );

  if (!show) return null;

  return (
    <div className="virtual-keyboard-overlay" onClick={onClose}>
      <div className="virtual-keyboard" onClick={(e) => e.stopPropagation()}>
        <div className="keyboard-header">
          <button className="close-button" onClick={onClose}>×</button>
        </div>
        {mode === 'numeric' ? renderNumericKeyboard() : renderTextKeyboard()}
      </div>
    </div>
  );
};

export default VirtualKeyboard;
